import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { getAdminRoutesAvailability } from 'src/routes/state/routesSelector';
import { useAppSelector } from 'src/store';
import ProtectedRoute from 'src/routes/ProtectedRoute';
import PageNotFound from 'src/shared/components/page-not-found/PageNotFound';
import { AdminViews, IndividualRouteSetting } from 'src/routes/routesConfig';
import { Resources } from 'src/shared/types';
import NaturePerformance from './views/nature-performance/NaturePerformance';
import OrgManagement from './views/organisations/OrgManagement';
import UserManagement from './views/user-management/UserManagement';
import RiskPortfolio from './views/risk-portfolio/RiskPortfolio';
import EngineApiTokens from './views/engine-api-tokens/EngineApiTokens';
import StacCatalogue from './views/stac-catalogue/StacCatalogue';
import EstateManagement from './views/estate-management/EstateManagement';

export const adminRouteSettings: { [key in AdminViews]: IndividualRouteSetting } = {
    gnpManagement: {
        name: 'Org Management',
        path: '/management/*',
        handler: <NaturePerformance />,
        resource: Resources.ADMIN_ORG_MANAGEMENT,
    },
    organisations: {
        name: 'Organisations',
        // Platform-wide, so it sits outside the organisation-scoped areas rather than within one.
        path: '/organisations',
        handler: <OrgManagement />,
        resource: Resources.ADMIN_ORG_MANAGEMENT,
    },
    userManagement: {
        name: 'Admin User Mgt.',
        path: '/user-management',
        handler: <UserManagement />,
        resource: Resources.ADMIN_USER_MANAGEMENT,
    },
    riskPortfolio: {
        name: 'Nature Risk',
        // A sibling of '/management/*' rather than a child, so it keeps its own permission.
        path: '/management/nature-risk/*',
        handler: <RiskPortfolio />,
        resource: Resources.ADMIN_RISK_PORTFOLIO,
    },
    engineApiTokens: {
        name: 'Engine API Tokens',
        path: '/engine-api-tokens',
        handler: <EngineApiTokens />,
        resource: Resources.ADMIN_ENGINE_API_TOKENS,
    },
    estateManagement: {
        name: 'Estate Management',
        path: '/estate-management',
        handler: <EstateManagement />,
        resource: Resources.ADMIN_ORG_MANAGEMENT,
    },
    geospatialCatalogue: {
        name: 'Geospatial Catalogue',
        // A wildcard: the catalogue nests datasets and their versions beneath it.
        path: '/catalogue/*',
        handler: <StacCatalogue />,
        resource: Resources.ADMIN_GEOSPATIAL_CATALOGUE,
    },
};

const Admin = () => {
    const routesConfig = useAppSelector(getAdminRoutesAvailability);

    if (!routesConfig) {
        return null;
    }

    return (
        <Routes>
            {Object.keys(routesConfig).map(routeKey => {
                const isAvailable = routesConfig[routeKey as AdminViews];
                const routeSetting = adminRouteSettings[routeKey as AdminViews];

                return (
                    <Route
                        path={routeSetting.path}
                        element={
                            <ProtectedRoute isAllowed={isAvailable} redirectPath={'/customers'} routeSetting={routeSetting}>
                                {routeSetting.handler}
                            </ProtectedRoute>
                        }
                        key={routeSetting.name}
                    />
                );
            })}
            <Route path='/*' element={<PageNotFound />} />
        </Routes>
    );
};
export default Admin;
